export function Footer() {
  return (
    <footer style={{ marginTop: "5em"}}>
      Made with <span className="love">♥</span> by{" "}
      <a href="https://pranabdas.github.io/">Pranab</a>.
    </footer>
  );
}
